import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
// Models
import IQuiz from 'models/Quiz';
// Components
import QuestionItem from './QuestionItem';

const QuestionsList:FC = () => {
  const quiz:IQuiz = useAppSelector(selectQuiz);

  return (
    <div className="px-2">
      {quiz.questions.map(question => (
        <QuestionItem
          key={question.ref}
          question={question}
          showQuestion={quiz.questions.length > 1}
        />
      ))}
    </div>
  )
}

export default QuestionsList;
